
import { Component, Vue} from 'vue-property-decorator';


@Component
export default class OtherPartyPopupNpr extends Vue { 
   
}
